module.exports = __webpack_public_path__ + "static/media/Adrien Stanley Headshot_1658234838837.4616ec8b.jpeg";